module.exports = __webpack_public_path__ + "img/ethereum.a84f4852.jpg";